import { CheckCircleTwoTone, CloseCircleTwoTone, InfoCircleTwoTone } from '@ant-design/icons';
import { Card, Empty, notification, Popover } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
} from 'recharts';
import { useDailyPnlMutation } from '../../slices/zerodhaApiSlice';
import { setDailypnl } from '../../slices/dailypnlSlice';
import moment from 'moment-timezone';

const BarBothSideChart = (props) => {
  moment.tz.setDefault("Asia/Calcutta|Asia/Kolkata");
  const { date } = props;
  const netdailypnlinfo = (
    <div>
      Net Daily P&L data Example:
      <ul>
        <li>2024-09-01: $1500</li>
        <li>2024-09-02: -$500</li>
        <li>2024-09-03: $2500</li>
        <li>2024-09-04: -$1000</li>
        <li>2024-09-05: $800</li>
      </ul>
    </div>
  );
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();
  const { dailypnl } = useSelector((state) => state.dailypnl);
  const [data, setData] = useState([]);

  const [dailyPnl, { isLoading }] = useDailyPnlMutation();

  const getDailyPnl = async (startDate, endDate) => {
    try {
      const res = await dailyPnl({ startDate, endDate }).unwrap();
      dispatch(setDailypnl({ ...res }));
    } catch (err) {
      console.log(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error,
      });
    }
  };

  useEffect(() => {
    getDailyPnl(date.startDate, date.endDate);
  }, [date]);

  useEffect(() => {
      setData(dailypnl); // Update local data state
  }, [dailypnl]);



    const CustomAntTooltip = ({ payload, label }) => {
        if (payload && payload.length) {
          const { pnl } = payload[0].payload;
          return (
            <div className="background-blur" style={{padding: "10px", width: "150px", textAlign: "left", color: "#000"}}>
              <p style={{fontSize: "12px"}}>{pnl >= 0 ? (<><CheckCircleTwoTone twoToneColor={"#2ecc71"}/> Profit</>) : (<><CloseCircleTwoTone twoToneColor={"#e74c3c"}/> Loss</>)}</p>
              <p style={{fontSize: "12px"}}>Date: {moment(new Date(label)).format('YYYY/MM/DD')}</p>
              <p style={{fontSize: "12px"}}>{pnl >= 0 ? "Profit": "Loss" }: ₹ {Number(pnl).toFixed(2)}</p>
            </div>
    
          );
        }
        return null;
        };

    return (
      <Card title={`Net Daily P&L`} loading={isLoading} extra={<Popover content={netdailypnlinfo} placement="left" title="Net Daily P&L"><InfoCircleTwoTone style={{marginRight: "20px"}}/></Popover>} bordered={false} className='card_hover'>
          {contextHolder}
          <div style={{height: 250, textAlign: "center", marginBottom: "20px"}}>
          {data != null && data.length > 0 ? (
              <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                  width={500}
                  height={300}
                  data={data}
                  margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5,
                  }}
                  >
                  <XAxis dataKey="date" style={{ fontSize: "10px" }} tickFormatter={(value) => `${moment(new Date(value)).format('YYYY/MM/DD')}`} />
                  <YAxis domain={['auto', 'auto']} tickFormatter={(value) => `₹ ${Number(value).toFixed(2)}`} style={{ fontSize: "10px" }}/>
                  <Tooltip content={<CustomAntTooltip />} />
                  <ReferenceLine y={0} stroke="#000" />
                  <Bar dataKey="pnl">
                      {data.map((entry, index) => (
                      <Cell
                          key={`cell-${index}`}
                          fill={entry.pnl >= 0 ? '#82ca9d' : '#ff4d4f'}
                      />
                      ))}
                  </Bar>
                  </BarChart>
              </ResponsiveContainer>
          ): (
            <ResponsiveContainer width="100%" height="100%" style={{alignContent: "center"}}>
              <Empty/>
            </ResponsiveContainer>
          )}
          </div>
      </Card>
    );

}
export default BarBothSideChart
